import { render, staticRenderFns } from "./Tank.vue?vue&type=template&id=35e45ae2&"
import script from "./Tank.vue?vue&type=script&lang=js&"
export * from "./Tank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports